import React from 'react';
import { WifiOff, RefreshCw, CloudOff, Check } from 'lucide-react';
import { useOffline } from '@/hooks/useOffline';

export function OfflineBanner() {
  const { isOffline, pendingCount, syncMessage, manualSync } = useOffline();

  // Sync success toast
  if (syncMessage) {
    return (
      <div
        data-testid="offline-sync-banner"
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2 px-4 py-2.5 rounded-xl bg-emerald-600 text-white shadow-lg animate-in slide-in-from-bottom-4 duration-300"
      >
        <Check className="w-4 h-4" />
        <span className="text-sm font-medium">{syncMessage}</span>
      </div>
    );
  }

  if (!isOffline && pendingCount === 0) return null;

  return (
    <div
      data-testid="offline-banner"
      className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-4 py-2.5 rounded-xl shadow-lg animate-in slide-in-from-bottom-4 duration-300 ${
        isOffline
          ? 'bg-amber-600 text-white'
          : 'bg-sky-600 text-white'
      }`}
    >
      {isOffline ? (
        <>
          <WifiOff className="w-4 h-4 flex-shrink-0" />
          <div className="flex flex-col">
            <span className="text-sm font-semibold">Mode offline</span>
            <span className="text-xs opacity-90">
              {pendingCount > 0
                ? `${pendingCount} operació(ns) pendent(s) de sincronitzar`
                : 'Les dades en cache estan disponibles'}
            </span>
          </div>
          <CloudOff className="w-3.5 h-3.5 opacity-60" />
        </>
      ) : (
        <>
          <RefreshCw className="w-4 h-4 flex-shrink-0" />
          <span className="text-sm font-medium">
            {pendingCount} operació(ns) pendent(s)
          </span>
          <button
            onClick={manualSync}
            data-testid="offline-sync-btn"
            className="ml-1 px-2.5 py-1 bg-white/20 hover:bg-white/30 rounded-lg text-xs font-semibold transition-colors"
          >
            Sincronitzar
          </button>
        </>
      )}
    </div>
  );
}
